import React from 'react';

export interface OnboardingStep {
  id: string;
  label: string;
  icon: React.ReactNode;
}

interface OnboardingStepNavProps {
  heading: string;
  subtitle?: string;
  steps: OnboardingStep[];
  /** The id of the currently active step; earlier steps render as completed. */
  activeId: string;
}

/**
 * Step list rendered as the body of the shared {@link LeftSidePanel} for onboarding flows
 * (company setup + per-user onboarding). It is content only — the panel chrome (gradient,
 * logo, glow) comes from LeftSidePanel so onboarding matches the rest of the app.
 */
const OnboardingStepNav: React.FC<OnboardingStepNavProps> = ({ heading, subtitle, steps, activeId }) => {
  const activeIndex = steps.findIndex((s) => s.id === activeId);

  return (
    <div className="text-white">
      <div className="mb-6 px-2">
        <h2 className="font-bold text-lg leading-snug mb-1">{heading}</h2>
        {subtitle && <p className="text-white/50 text-xs">{subtitle}</p>}
      </div>

      <div className="space-y-1">
        {steps.map((step, idx) => {
          const isActive = step.id === activeId;
          const isDone = idx < activeIndex;
          return (
            <div
              key={step.id}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition ${
                isActive ? 'bg-white/15 text-white font-medium' : isDone ? 'text-white/70' : 'text-white/40'
              }`}
            >
              <span className="flex-shrink-0">{step.icon}</span>
              {step.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OnboardingStepNav;
